<template>
  <div class="books_warp">

    <div class="books_container">

      <div class="bookBox">
        <div class="section-title">
          <div class="title-block">
            <img src="./../../../assets/lzk/title-icon.png" alt="" srcset="">
          </div>
          <h2>专家学者</h2>
        </div>
        <div class="Xflex_box">
          <superslide :options="options" class="picMarquee-left" v-if="hackReset">
            <div class="bd">
              <ul class="picList" ref="sliderWrap">
                <li class="readerItem" v-for="(item, i) in bookList" :key="item.scholarId" :data-id="item.scholarId"
                 >
                  <div class="cover">
                    <img :src="item.image" :alt="item.name" />
                  </div>
                  <div class="title">{{ item.scholarName }}</div>
                </li>
              </ul>
            </div>

            <div class="hd" slot="titCell"></div>
            <div class="prev" slot="prev"></div>
            <div class="next" slot="next"></div>
          </superslide>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getListByDepartmentResourceScholarRecommend, getListBySpecialResourceScholarRecommend } from '@/lzk/api/subjectResource';
export default {
  name: "picScrollLeft",
  data() {
    return {
      hackReset: true,
      bookList: [],
      options: {
        titCell: ".hd ul",
        mainCell: ".bd ul",
        autoPage: true,
        effect: "leftLoop",
        autoPlay: false,
        vis: 5,
      },
    };
  },
  watch: {},
  computed: {
    id() { //系科/专科
      return this.$route.params.id;
    },
    cid() {
      return this.$route.params.cid;
    },
    cname() {    // 缓存页面cname
      return this.$route.params.cname;
    },

  },
  methods: {
    toDetail(item) {
      console.log(item,this.bookList)
      let data = this.bookList.find(i=>i.scholarId==item)
      sessionStorage.setItem('readerDetail', JSON.stringify(data))
      this.$router.push({ path: `/subjectresources/readerDetail/${this.id}/${this.cid}/${this.cname}` });

    },
    async loadList() {
      this.hackReset = false;
      let data = null
      if (this.$route.params.id == 1) { //系科
        data = await getListByDepartmentResourceScholarRecommend(this.$route.params.cid)//系科查电子资源
      } else { //专科
        data = await getListBySpecialResourceScholarRecommend(this.$route.params.cid)//专科查学者
      }
      console.log(data)
      this.bookList = data.data
      this.hackReset = true;
      this.eventListener();
    },
    handlerClick(e) {
      console.log(e)
      //获取点击元素的公共父级li;
      const li = e.target.closest("li");
      console.log(li.dataset)
      this.toDetail(li.dataset.id);
    },
    eventListener() {
      this.$nextTick(() => {
        const sliderWrap = this.$refs.sliderWrap;
        sliderWrap.addEventListener("click", this.handlerClick);
      });
    },
  },
  mounted() { },
  created() {
    this.loadList();
  },
};
</script>

<style>
/* 本例子css */
.picMarquee-left {
  /* overflow: hidden; */
  position: relative;
  width: 100%;
}

.picMarquee-left .hd {
  height: 0px;
}

.picMarquee-left .bd {
  width: 100%;
  padding: 10px;
}

.picMarquee-left .bd ul {
  overflow: hidden;
  zoom: 1;
}

.picMarquee-left .bd ul li {
  margin: 0 21px;
  float: left;
  overflow: hidden;
}

.prev,
.next {
  position: absolute;
  display: block;
  overflow: hidden;
  cursor: pointer;
  height: 58px;
  width: 34px;
  background: url(../../../assets/index/srightbg.png);
}

.next {
  right: -26px;
  top: 83px;
}

.prev {
  left: -21px;
  top: 83px;
  background: url(../../../assets/index/sleftbg.png);
}
</style>

<style scoped lang="scss">
.section-title {
  display: flex;
  align-items: center;
  margin: 30px 0 15px 0;

  h2 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .more {
    margin-left: auto;
    cursor: pointer;
  }
}

.box3 {
  border-top: 100px solid #004896;
  border-right: 100px solid transparent;
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0px;
  left: 0px;
}

.books_warp {
  background: #e2f1ff;
  margin-bottom: 50px;

  .books_container {
    width: 1200px;
    height: 100%;
    padding: 10px 0 99px 20px;
    margin: 0 auto;
    position: relative;

    .bookBox {
      position: relative;
      width: 100%;
      // padding: 0 26px 50px 20px;
      height: 275px;
      left: 0px;

      .more {
        cursor: pointer;
        position: absolute;
        right: 0;
        width: 100px;
        color: #ed8016;
      }

      .Xflex_box {
        width: 100%;
      }

      .readerItem .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 20px;
        color: #4579BC;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        margin-top: 20px;
      }

      .readerItem:hover .info .title {
        color: #1981f8;
      }

      .readerItem .info-item {
        padding: 4px 0;
      }

      .readerItem {
        cursor: pointer;
        display: flex;
        margin-top: 10px;
        flex-direction: column;
        width: 16%;
        text-align: center;

        img {
          height: 220px;
          width: 170px;
          border: 0;

        }

        .cover:hover img {
          transform: scale(1.2);
          transition: all 1s ease 0s;
          -webkit-transform: scale(1.2);
          -webkit-transform: all 1s ease 00s;
        }
      }
    }
  }
}
</style>
